(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anglers-roster"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pg-roster]').forEach(function (root) {
    var chips = root.querySelector('[data-pg-chips]');
    var grid = root.querySelector('[data-pg-grid]');
    if (!chips || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pg-series]'));
    var live = root.querySelector('[data-pg-live]');
    var empty = root.querySelector('[data-pg-empty]');

    root.querySelectorAll('[data-pg-count]').forEach(function (slot) {
      var key = slot.getAttribute('data-pg-count');
      slot.textContent = key === '*'
        ? cards.length
        : cards.filter(function (c) { return c.getAttribute('data-pg-series') === key; }).length;
    });

    function apply(key, label) {
      var visible = 0;
      cards.forEach(function (card) {
        var show = key === '*' || card.getAttribute('data-pg-series') === key;
        card.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
      if (live) {
        live.textContent = key === '*'
          ? visible + ' anglers, all circuits'
          : visible + ' anglers in ' + label;
      }
    }

    chips.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pg-filter]');
      if (!button) return;
      chips.querySelectorAll('[data-pg-filter]').forEach(function (other) {
        var on = other === button;
        other.classList.toggle('pg-ros__chip--on', on);
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var key = button.getAttribute('data-pg-filter');
      apply(key, key);
    });

    chips.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-desk"] && !Shopify.designMode) return;
  try {
    
(function () {
  var panel = document.getElementById('send-a-message');
  if (!panel || panel.tagName.toLowerCase() !== 'details') return;

  // The fields are display:none until the panel opens, so focus has to wait for
  // the browser to apply that — `toggle` fires once it has, which a single
  // animation frame did not reliably beat.
  panel.addEventListener('toggle', function () {
    if (!panel.open || !panel.dataset.pgFocus) return;
    delete panel.dataset.pgFocus;
    var first = panel.querySelector('input:not([type="hidden"]), textarea');
    if (first) first.focus({ preventScroll: true });
  });

  function reveal() {
    panel.dataset.pgFocus = '1';
    panel.open = true;
    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#send-a-message"]');
    if (!link) return;
    event.preventDefault();
    if (history.replaceState) history.replaceState(null, '', '#send-a-message');
    reveal();
  });

  // A posted form must never be hidden: Shopify returns to #contact_form, and
  // default_errors renders ul.errors inside the panel.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-pg-close-form]')) return;
    panel.open = false;
    var back = document.querySelector('a[href$="#send-a-message"]');
    if (back) back.focus({ preventScroll: true });
  });

  if (panel.querySelector('.pg-con__ok, .errors')) {
    panel.open = true;
  } else if (window.location.hash === '#send-a-message' || window.location.hash === '#contact_form') {
    reveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function init() {
    var form = document.querySelector('[data-pgp-cart-form]');
    if (!form) return;
    var timer = null;
    var submitSoon = function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 500);
    };
    form.querySelectorAll('[data-pgp-cart-qty]').forEach(function (w) {
      var input = w.querySelector('input');
      w.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          if (b.getAttribute('data-action') === 'inc') { v += 1; } else { v = Math.max(0, v - 1); }
          input.value = v;
          submitSoon();
        });
      });
      input.addEventListener('change', submitSoon);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // "Complete your setup" add buttons: add through the AJAX cart, then reload
  // so line items, totals and any discount re-render server-side.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pgp-cart-addon]');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-pgp-cart-addon')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); window.location.reload(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-buy-box"]) return;
  try {
    
(function () {
  function init() {
    var gallery = document.querySelector('[data-pgp-gallery]');
    if (gallery) {
      var main = gallery.querySelector('[data-pgp-main]');
      var rail = gallery.querySelector('[data-pgp-thumbrail]');
      var prev = gallery.querySelector('[data-pgp-thumbnav="prev"]');
      var next = gallery.querySelector('[data-pgp-thumbnav="next"]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pgp-thumb]'));

      var currentIndex = function () {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains('is-active')) return i;
        }
        return 0;
      };
      var updNav = function () {
        if (!prev || !next) return;
        var i = currentIndex();
        prev.disabled = i <= 0;
        next.disabled = i >= thumbs.length - 1;
      };
      var activate = function (i) {
        var t = thumbs[i];
        if (!t || !main) return;
        main.src = t.getAttribute('data-full');
        main.removeAttribute('srcset');
        thumbs.forEach(function (a) { a.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (rail) {
          var rr = rail.getBoundingClientRect();
          var tr = t.getBoundingClientRect();
          rail.scrollBy({ left: tr.left - rr.left - (rail.clientWidth - tr.width) / 2, behavior: 'smooth' });
        }
        updNav();
      };
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
      });
      if (prev) prev.addEventListener('click', function () { activate(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { activate(currentIndex() + 1); });
      updNav();
    }

    document.querySelectorAll('[data-pgp-qty]').forEach(function (w) {
      var input = w.querySelector('input');
      w.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          if (b.getAttribute('data-action') === 'inc') { v += 1; } else { v = Math.max(1, v - 1); }
          input.value = v;
        });
      });
    });

    var dataEl = document.querySelector('[data-pgp-variants]');
    var selects = Array.prototype.slice.call(document.querySelectorAll('[data-pgp-option]'));
    if (!dataEl || !selects.length) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    function sync() {
      var opts = selects.map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
      if (!match) return;
      document.querySelectorAll('.pgp-variant-sync').forEach(function (i) { i.value = match.id; });
      document.querySelectorAll('[data-pgp-price]').forEach(function (el) {
        el.textContent = fmt.format(match.price / 100);
      });
      document.querySelectorAll('[data-pgp-was]').forEach(function (el) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          el.textContent = fmt.format(match.compare_at_price / 100);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      document.querySelectorAll('[data-pgp-permo]').forEach(function (el) {
        var m = parseInt(el.getAttribute('data-months'), 10) || 12;
        el.textContent = '$' + Math.ceil(match.price / m / 100) + '/mo';
      });
      document.querySelectorAll('[data-pgp-atc]').forEach(function (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available
          ? btn.getAttribute('data-label-add')
          : btn.getAttribute('data-label-oos');
      });
      document.querySelectorAll('[data-pgp-availability]').forEach(function (el) {
        el.classList.toggle('is-oos', !match.available);
        var t = el.querySelector('[data-text]');
        if (t) t.textContent = match.available ? el.getAttribute('data-in') : el.getAttribute('data-out');
      });
    }
    selects.forEach(function (s) { s.addEventListener('change', sync); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-value"]) return;
  try {
    
(function () {
  var GRAPHS = [
    { name: 'Garmin GPSMAP 400/500 Series', amps: 1.0 },
    { name: 'Garmin GPSMAP 700 Series', amps: 1.5 },
    { name: 'Garmin GPSMAP 800/1000 Series', amps: 2.5 },
    { name: 'Garmin GPSMAP 7400/7600 Series', amps: 3.5 },
    { name: 'Garmin GPSMAP 8400/8600 Series', amps: 6.0 },
    { name: 'Garmin ECHOMAP CHIRP', amps: 1.5 },
    { name: 'Garmin ECHOMAP Plus / UHD', amps: 2.0 },
    { name: 'Garmin ECHOMAP Ultra', amps: 3.0 },
    { name: 'Garmin STRIKER / Plus / Vivid', amps: 1.0 },
    { name: 'Lowrance HDS Gen1', amps: 1.5 },
    { name: 'Lowrance HDS Gen2 / Gen2 Touch', amps: 1.5 },
    { name: 'Lowrance HDS Gen3', amps: 1.6 },
    { name: 'Lowrance HDS Carbon', amps: 2.0 },
    { name: 'Lowrance HDS LIVE', amps: 2.5 },
    { name: 'Raymarine Axiom XL', amps: 7.0 },
    { name: 'Raymarine Dragonfly', amps: 1.0 }
  ];

  function init() {
    document.querySelectorAll('[data-pgp-calc]').forEach(function (calc) {
      calc.querySelectorAll('[data-pgp-calc-graph]').forEach(function (sel) {
        var none = document.createElement('option');
        none.value = '0';
        none.textContent = 'None';
        sel.appendChild(none);
        GRAPHS.forEach(function (g) {
          var o = document.createElement('option');
          o.value = g.amps;
          o.textContent = g.name + ' (' + g.amps + 'A)';
          sel.appendChild(o);
        });
      });

      var addBtn = calc.querySelector('[data-pgp-calc-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var slot = calc.querySelector('[data-pgp-calc-slot][hidden]');
          if (slot) slot.hidden = false;
          if (!calc.querySelector('[data-pgp-calc-slot][hidden]')) addBtn.hidden = true;
        });
      }

      var go = calc.querySelector('[data-pgp-calc-go]');
      if (!go) return;
      go.addEventListener('click', function () {
        var total = 0;
        calc.querySelectorAll('[data-pgp-calc-graph]').forEach(function (s) {
          total += parseFloat(s.value) || 0;
        });
        total = Math.round(total * 10) / 10;
        var hoursEl = calc.querySelector('[data-pgp-calc-hours]');
        var hours = parseFloat(hoursEl && hoursEl.value);
        var result = calc.querySelector('[data-pgp-calc-result]');
        var math = calc.querySelector('[data-pgp-calc-math]');
        var note = calc.querySelector('[data-pgp-calc-note]');
        var cards = Array.prototype.slice.call(calc.querySelectorAll('[data-pgp-calc-card]'));
        cards.sort(function (a, b) {
          return parseFloat(a.getAttribute('data-capacity')) - parseFloat(b.getAttribute('data-capacity'));
        });

        if (!total || !hours || hours <= 0) {
          cards.forEach(function (c) { c.hidden = true; });
          math.textContent = 'Pick at least one graph and enter your hours, then hit calculate.';
          note.textContent = '';
          result.hidden = false;
          return;
        }

        var required = Math.round(total * hours * 10) / 10;
        var pick = null;
        var parallel = false;
        for (var i = 0; i < cards.length; i++) {
          if (parseFloat(cards[i].getAttribute('data-capacity')) * 0.8 >= required) { pick = cards[i]; break; }
        }
        if (!pick && cards.length) {
          pick = cards[cards.length - 1];
          parallel = true;
        }
        cards.forEach(function (c) {
          c.hidden = c !== pick;
          var qty = c.querySelector('[data-pgp-calc-qty]');
          if (qty) qty.hidden = !(c === pick && parallel);
        });
        math.textContent = total + 'A × ' + hours + ' hours = ' + required + 'Ah needed';
        if (pick && parallel) {
          note.textContent = 'That draw is beyond a single battery — run two ' + pick.getAttribute('data-name') + ' in parallel, or call a battery expert to size your setup.';
        } else if (pick) {
          note.textContent = 'The ' + pick.getAttribute('data-name') + ' covers your ' + required + 'Ah with usable capacity to spare.';
        } else {
          note.textContent = '';
        }
        result.hidden = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdpv2-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ---- detail tabs ------------------------------------------------------
     Moved here with the markup from pdpv2-detail. A theme file may declare only
     ONE javascript block, so this is folded into the buy-box's existing one
     rather than added as a second. */
  function initTabs(root) {
    if (!root || root.dataset.pgv2DetailReady === '1') return;
    root.dataset.pgv2DetailReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pgv2-buy__tab'));
    if (!tabs.length) return;

    var panels = tabs.map(function (tab) {
      return root.querySelector('#' + tab.getAttribute('aria-controls'));
    });

    function select(i) {
      tabs.forEach(function (tab, j) {
        var on = i === j;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (panels[j]) panels[j].hidden = !on;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (next === null) return;
        event.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });

    select(0);
  }

  function init(root) {
    if (!root || root.dataset.pgv2Ready === '1') return;
    root.dataset.pgv2Ready = '1';

    root.querySelectorAll('[data-pgv2-detail]').forEach(initTabs);

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* ---- gallery ---- */
    var main = root.querySelector('[data-pgv2-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pgv2-thumb]'));
    var dotsHost = root.querySelector('[data-pgv2-dots]');
    var index = 0;

    function paint() {
      var thumb = thumbs[index];
      if (!thumb) return;
      if (main) main.src = thumb.dataset.full;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (dotsHost) {
        Array.prototype.forEach.call(dotsHost.children, function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }
      var prev = root.querySelector('[data-pgv2-step="prev"]');
      var next = root.querySelector('[data-pgv2-step="next"]');
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= thumbs.length - 1;
      if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { index = i; paint(); });
      if (dotsHost) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'View image ' + (i + 1));
        dot.addEventListener('click', function () { index = i; paint(); });
        dotsHost.appendChild(dot);
      }
    });

    root.querySelectorAll('[data-pgv2-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        index += btn.dataset.pgv2Step === 'next' ? 1 : -1;
        if (index < 0) index = 0;
        if (index > thumbs.length - 1) index = thumbs.length - 1;
        paint();
      });
    });
    if (thumbs.length) paint();

    /* ---- quantity: both steppers stay in step ---- */
    var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pgv2-qtyinput]'));

    function currentQty() {
      var n = parseInt(qtyInputs[0] && qtyInputs[0].value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function setQty(n) {
      if (n < 1) n = 1;
      qtyInputs.forEach(function (i) { i.value = n; });
      paintTotal();
    }

    root.querySelectorAll('[data-pgv2-qty] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(currentQty() + (btn.dataset.action === 'inc' ? 1 : -1));
      });
    });
    qtyInputs.forEach(function (input) {
      input.addEventListener('change', function () { setQty(parseInt(input.value, 10)); });
    });

    /* ---- running total: unit price x qty + ticked add-ons ---- */
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-pgv2-addon]'));
    var totalEl = root.querySelector('[data-pgv2-total]');
    var variantField = root.querySelector('[data-pgv2-variant]');
    var variants = [];
    var variantJson = root.querySelector('[data-pgv2-variants]');
    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent) || []; } catch (e) { variants = []; }
    }

    function unitCents() {
      var id = variantField && parseInt(variantField.value, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i].price;
      }
      return variants.length ? variants[0].price : 0;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function paintTotal() {
      if (!totalEl) return;
      var cents = unitCents() * currentQty();
      addons.forEach(function (box) {
        if (box.checked) cents += parseInt(box.dataset.price, 10) || 0;
      });
      totalEl.textContent = formatMoney(cents);
    }

    addons.forEach(function (box) { box.addEventListener('change', paintTotal); });
    paintTotal();

    /* ---- add to cart: main product plus any ticked add-ons, one request ---- */
    var form = root.querySelector('[data-pgv2-atc]') ? root.querySelector('[data-pgv2-atc]').form : null;
    var errorEl = root.querySelector('[data-pgv2-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || 'Could not add to cart.';
      errorEl.hidden = false;
    }

    function submitCart(button) {
      if (!variantField || !variantField.value) return;
      var items = [{ id: variantField.value, quantity: currentQty() }];
      addons.forEach(function (box) {
        if (box.checked) items.push({ id: box.value, quantity: 1 });
      });

      if (errorEl) errorEl.hidden = true;
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function () { window.location.href = routeRoot + 'cart'; })
        .catch(function (err) {
          if (button) { button.disabled = false; button.textContent = label; }
          showError(err.message);
        });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitCart(root.querySelector('[data-pgv2-atc]'));
      });
    }

    var stickyAdd = root.querySelector('[data-pgv2-stickyadd]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () { submitCart(stickyAdd); });
    }

    liftChatWidget(root);
  }

  /* ---- keep the Switchboard launcher off the sticky Add to Cart ----------
     The launcher is `position: fixed; bottom: 14px; right: 14px` inside the
     widget's shadow root, so it sits directly over the CTA on a phone and
     swallows the tap — a hit test at the button's centre returned the chat
     host, not the button. The shadow root is open, so the fix is a small
     stylesheet adopted into it. Everything is guarded: if Switchboard's
     internals change, the PDP is unaffected and the widget simply stays put. */
  function liftChatWidget(root) {
    var sticky = root.querySelector('[data-pgv2-sticky]');
    if (!sticky) return;

    function lift() {
      var clearance = sticky.offsetHeight + 14;
      if (!clearance || clearance < 40) clearance = 92;
      document.documentElement.style.setProperty('--pgv2-chat-lift', clearance + 'px');

      var host = document.querySelector('[data-switchboard-chat]');
      if (!host || !host.shadowRoot) return false;

      try {
        var style = host.shadowRoot.querySelector('[data-pgv2-chat-lift]');
        if (!style) {
          style = document.createElement('style');
          style.setAttribute('data-pgv2-chat-lift', '');
          host.shadowRoot.appendChild(style);
        }
        style.textContent =
          '@media (max-width: 749px){.sb-launcher,.sb-panel{bottom:' + clearance + 'px !important;}}';
        return true;
      } catch (e) {
        return false;
      }
    }

    if (!lift()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (lift() || ++tries > 40) clearInterval(timer);
      }, 250);
    }

    window.addEventListener('resize', lift);
  }

  function boot() {
    document.querySelectorAll('[data-pgv2-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdpv3-buy-box"]) return;
  try {
    
class PgV3Pdp {
  constructor(root) {
    this.root = root;
    this.bindStickyGallery();
    this.bindGallery();
    this.bindQuantity();
    this.bindAddons();
    this.bindZoom();
    this.bindTabs();
    this.bindVariants();
    this.bindStickyBar();
  }

  bindStickyBar() {
    // Phones: show the bar while the form's own Add to Cart is off screen.
    const bar = this.root.querySelector('[data-pgv3-sticky]');
    const atc = this.root.querySelector('.pgv3-cart .pgv3-atc');
    if (!bar || !atc || !window.IntersectionObserver) return;
    const btn = bar.querySelector('[data-pgv3-sticky-atc]');
    document.body.classList.add('pgv3-sticky-page');
    new IntersectionObserver(([entry]) => {
      const on = !entry.isIntersecting;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('pgv3-sticky-up', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      // Mirror the main button: the variant picker can change both.
      btn.disabled = atc.disabled;
      btn.textContent = atc.textContent.trim();
    }).observe(atc);
  }

  bindVariants() {
    const sel = this.root.querySelector('[data-pgv3-variant]');
    if (!sel) return;
    const now = this.root.querySelector('.pgv3-price__now');
    const promise = this.root.querySelector('.pgv3-price__promise');
    const apply = () => {
      const o = sel.selectedOptions[0];
      if (!o) return;
      if (now) now.textContent = o.dataset.price;
      const stickyPrice = this.root.querySelector('[data-pgv3-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = o.dataset.price;
      let was = this.root.querySelector('.pgv3-price__was');
      if (o.dataset.was) {
        if (!was && now) {
          was = document.createElement('s');
          was.className = 'pgv3-price__was';
          now.before(was);
        }
        if (was) was.textContent = o.dataset.was;
        if (promise) promise.textContent = 'You save ' + o.dataset.save;
      } else {
        if (was) was.remove();
        // Back to full price: drop the saving, restore the default (blank).
        if (promise) promise.textContent = promise.dataset.pgv3PromiseDefault || '';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', o.value);
      window.history.replaceState({}, '', url);
    };
    sel.addEventListener('change', apply);
  }

  bindStickyGallery() {
    // Drives --pgv3-stick-top so the gallery pins by its BOTTOM edge once it is
    // taller than the window. See the .pgv3__gallery--stick rule for the why.
    const gal = this.root.querySelector('.pgv3__gallery');
    if (!gal) return;
    const GAP = 24;
    const narrow = window.matchMedia('(max-width: 900px)');
    const apply = () => {
      if (narrow.matches) {
        // Single column below 900px: the stylesheet forces position:static there,
        // so leave top alone rather than fighting it.
        gal.style.removeProperty('--pgv3-stick-top');
        return;
      }
      const h = gal.offsetHeight;
      const vh = window.innerHeight;
      const top = h + GAP * 2 <= vh ? GAP : vh - h - GAP;
      gal.style.setProperty('--pgv3-stick-top', Math.round(top) + 'px');
    };
    apply();
    window.addEventListener('resize', apply, { passive: true });
    if (narrow.addEventListener) narrow.addEventListener('change', apply);
    // The height is not final until the photos have decoded, and swapping a
    // thumbnail into the lead frame can change it again. Setting a custom
    // property does not resize the element, so this cannot feed back on itself.
    if (window.ResizeObserver) new ResizeObserver(apply).observe(gal);
    gal.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', apply, { once: true });
    });
  }

  bindTabs() {
    const tabs = Array.from(this.root.querySelectorAll('.pgv3-tabs__heads button'));
    if (!tabs.length) return;
    const show = (tab) => {
      tabs.forEach((other) => {
        const panel = this.root.querySelector('#' + other.getAttribute('aria-controls'));
        const active = other === tab;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-selected', active ? 'true' : 'false');
        if (panel) panel.hidden = !active;
      });
    };
    // Overview links that open a specific tab ("Size & Compatibility",
    // "Full Specifications"), then bring the tab strip into view.
    this.root.querySelectorAll('[data-pgv3-open-tab]').forEach((link) => {
      const tab = this.root.querySelector('#' + link.dataset.pgv3OpenTab);
      if (!tab) return;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        show(tab);
        this.root.querySelector('.pgv3-tabs').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(tab));
      tab.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        const next = tabs[(i + step + tabs.length) % tabs.length];
        next.focus();
        show(next);
      });
    });
  }

  bindZoom() {
    const dialog = this.root.querySelector('[data-pgv3-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const full = dialog.querySelector('[data-pgv3-lightbox-img]');
    const close = dialog.querySelector('[data-pgv3-lightbox-close]');
    // Every full-width band carries its own zoom button now, not just the
    // first one, so the query has to be plural.
    const triggers = this.root.querySelectorAll('[data-pgv3-zoom]');
    if (!full || !triggers.length) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        // Read whatever THIS frame is showing right now -- the bands swap in
        // place, so the frame's src is the only source of truth.
        const frame = trigger.closest('.pgv3-photos__lead');
        const img = frame && frame.querySelector('img');
        if (!img) return;
        full.setAttribute('src', img.getAttribute('src').replace(/width=\d+/, 'width=1800'));
        full.setAttribute('alt', img.getAttribute('alt') || '');
        dialog.showModal();
      });
    });
    if (close) close.addEventListener('click', () => dialog.close());
    // Clicking the backdrop closes it: the dialog box itself is the img, so any
    // click landing outside that rect is on the backdrop.
    dialog.addEventListener('click', (event) => {
      const box = full.getBoundingClientRect();
      const outside = event.clientX < box.left || event.clientX > box.right
        || event.clientY < box.top || event.clientY > box.bottom;
      if (outside) dialog.close();
    });
  }

  bindAddons() {
    const wrap = this.root.querySelector('.pgv3-addons');
    if (!wrap) return;
    const addUrl = wrap.getAttribute('data-pgv3-cart-add');
    const changeUrl = wrap.getAttribute('data-pgv3-cart-change');
    const cartUrl = wrap.getAttribute('data-pgv3-cart-url');
    const msg = wrap.querySelector('[data-pgv3-addon-msg]');
    const say = (text, isError) => {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('is-error', Boolean(isError));
    };
    // The button holds both icons plus a label span; only the label text
    // changes, and CSS picks the icon from .is-added.
    const setLabel = (button, text) => {
      const label = button.querySelector('.pgv3-addons__add-label');
      if (label) label.textContent = text;
      else button.textContent = text;
    };

    // "Battery + 2 add-ons  $779.97": this product's price plus every add-on
    // marked Added. Hidden until at least one is added.
    const total = wrap.querySelector('[data-pgv3-addon-total]');
    const basePrice = Number(wrap.getAttribute('data-pgv3-base-price')) || 0;
    const currency = wrap.getAttribute('data-pgv3-currency') || 'USD';
    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    };
    const updateTotal = () => {
      if (!total) return;
      const added = Array.from(wrap.querySelectorAll('[data-pgv3-addon].is-added'));
      if (added.length === 0) {
        total.hidden = true;
        return;
      }
      const sum = added.reduce((acc, b) => acc + (Number(b.getAttribute('data-pgv3-addon-price')) || 0), basePrice);
      const base = total.getAttribute('data-pgv3-total-base') || 'This item';
      total.querySelector('[data-pgv3-addon-total-label]').textContent =
        base + ' + ' + added.length + (added.length === 1 ? ' add-on' : ' add-ons');
      total.querySelector('[data-pgv3-addon-total-value]').textContent = money(sum);
      total.hidden = false;
    };

    const refreshCount = async () => {
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .catch(() => null);
      if (cart && typeof cart.item_count === 'number') {
        document.querySelectorAll('[data-cart-count]').forEach((node) => {
          node.textContent = cart.item_count;
        });
      }
    };

    // Reflect what is already in the cart, so an add-on bought earlier reads
    // "Added" instead of inviting a second one (mobile audit, 25 Sep).
    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        if (!cart || !cart.items) return;
        wrap.querySelectorAll('[data-pgv3-addon]').forEach((button) => {
          const id = Number(button.getAttribute('data-pgv3-addon'));
          const line = cart.items.find((i) => i.variant_id === id);
          if (!line) return;
          const name = button.getAttribute('data-pgv3-addon-name') || 'That item';
          button.setAttribute('data-pgv3-addon-key', line.key);
          button.classList.add('is-added');
          setLabel(button, wrap.getAttribute('data-pgv3-added-label') || 'Added');
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Remove ' + name + ' from your cart');
        });
        updateTotal();
      })
      .catch(() => {});

    wrap.querySelectorAll('[data-pgv3-addon]').forEach((button) => {
      button.addEventListener('click', async () => {
        const id = Number(button.getAttribute('data-pgv3-addon'));
        const name = button.getAttribute('data-pgv3-addon-name') || 'That item';
        if (!id) return;
        const isAdded = button.classList.contains('is-added');

        button.disabled = true;
        button.classList.add('is-busy');
        say('');

        try {
          if (isAdded) {
            // Take off only the one this toggle stands for; the shopper may have
            // more of the same item in the cart already.
            const key = button.getAttribute('data-pgv3-addon-key');
            const current = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
            const line = current && current.items && current.items.find((i) => (key ? i.key === key : i.variant_id === id));
            const nextQty = line ? Math.max(0, line.quantity - 1) : 0;
            const response = await fetch(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: (line && line.key) || key || String(id), quantity: nextQty }),
            });
            const payload = await response.json().catch(() => null);
            if (!response.ok) {
              throw new Error((payload && (payload.description || payload.message)) || 'Could not remove that from your cart.');
            }
            button.classList.remove('is-added');
            button.removeAttribute('data-pgv3-addon-key');
            setLabel(button, wrap.getAttribute('data-pgv3-add-label') || 'Add');
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Add ' + name + ' to your cart');
            say(name + ' removed from your cart.');
          } else {
            const response = await fetch(addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
            });
            const payload = await response.json().catch(() => null);
            if (!response.ok) {
              throw new Error((payload && (payload.description || payload.message)) || 'Could not add that to your cart.');
            }
            const line = payload && payload.items && payload.items[0];
            if (line && line.key) button.setAttribute('data-pgv3-addon-key', line.key);
            button.classList.add('is-added');
            setLabel(button, wrap.getAttribute('data-pgv3-added-label') || 'Added');
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', 'Remove ' + name + ' from your cart');
            say(name + ' added to your cart. Click it again to remove it.');
          }
          updateTotal();
          await refreshCount();
        } catch (error) {
          say(error.message, true);
        } finally {
          button.disabled = false;
          button.classList.remove('is-busy');
        }
      });
    });
  }

  bindGallery() {
    // A thumbnail trades places with the nearest full-width frame ABOVE it, so
    // each band behaves on its own. Both tiles carry their own large and small
    // URLs, so a photo promoted to a frame is re-requested at frame size
    // rather than being upscaled from the 600px thumbnail.
    const wrap = this.root.querySelector('.pgv3-photos');
    if (!wrap) return;
    const tiles = Array.from(wrap.querySelectorAll('[data-pgv3-tile]'));
    if (tiles.length < 2) return;

    const read = (tile) => ({
      lg: tile.getAttribute('data-pgv3-lg'),
      sm: tile.getAttribute('data-pgv3-sm'),
      alt: tile.getAttribute('data-pgv3-alt') || ''
    });
    const paint = (tile, data) => {
      tile.setAttribute('data-pgv3-lg', data.lg);
      tile.setAttribute('data-pgv3-sm', data.sm);
      tile.setAttribute('data-pgv3-alt', data.alt);
      const img = tile.querySelector('img');
      if (!img) return;
      img.setAttribute('src', tile.hasAttribute('data-pgv3-big') ? data.lg : data.sm);
      img.setAttribute('alt', data.alt);
    };

    tiles.forEach((tile, index) => {
      if (tile.hasAttribute('data-pgv3-big')) return;
      tile.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 900px)').matches) return; // swipe strip on phones
        let frame = null;
        for (let i = index - 1; i >= 0; i -= 1) {
          if (tiles[i].hasAttribute('data-pgv3-big')) { frame = tiles[i]; break; }
        }
        if (!frame) return;
        const fromThumb = read(tile);
        const fromFrame = read(frame);
        tile.setAttribute('data-pgv3-fade', '');
        frame.setAttribute('data-pgv3-fade', '');
        window.setTimeout(() => {
          paint(frame, fromThumb);
          paint(tile, fromFrame);
          tile.removeAttribute('data-pgv3-fade');
          frame.removeAttribute('data-pgv3-fade');
        }, 150);
      });
    });
  }

  bindQuantity() {
    const input = this.root.querySelector('[data-pgv3-qty-input]');
    if (!input) return;
    this.root.querySelectorAll('[data-pgv3-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        const next = button.getAttribute('data-pgv3-qty') === 'up' ? current + 1 : current - 1;
        input.value = Math.max(1, next);
      });
    });
  }

}

document.querySelectorAll('.pgv3').forEach((root) => new PgV3Pdp(root));
  /* Dealer request (AJ, 17 Sep). The button beside "Call" opens the form in
     place. A posted form is forced open so the confirmation or the validation
     errors are never left behind a closed summary — `form` is only in scope
     inside the Liquid form tag, so that cannot be decided in Liquid. */
  (function () {
    var panel = document.getElementById('dealer-request');
    if (!panel || panel.tagName.toLowerCase() !== 'details') return;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pgv3-dealer-open]');
      if (!trigger) return;
      event.preventDefault();
      panel.open = true;
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      // The fields are display:none until the panel opens, so focusing in the
      // same frame is a no-op.
      requestAnimationFrame(function () {
        var first = panel.querySelector('input:not([type="hidden"]), textarea');
        if (first) first.focus({ preventScroll: true });
      });
    });

    if (panel.querySelector('.pgv3-dealer__ok, .errors')) panel.open = true;
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Filter dropdowns: auto-submit on checkbox change; close open popovers on outside click. */
  var form = document.getElementById('plp-filter-form');
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) form.submit();
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-plp-filter][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  }

  /* Pills: active when the pill's query string is contained in the current one;
     fall back to the bare-path pill when nothing matched. */
  var pills = Array.prototype.slice.call(document.querySelectorAll('[data-plp-pill]'));
  var matched = false;
  pills.forEach(function (p) {
    var href = p.getAttribute('href') || '';
    var q = href.split('?')[1];
    if (q && location.search.indexOf(q) !== -1) { p.classList.add('is-active'); matched = true; }
  });
  if (!matched) {
    for (var i = 0; i < pills.length; i++) {
      var href = pills[i].getAttribute('href') || '';
      if (href.indexOf('?') === -1 && location.pathname === href.replace(/\/$/, '')) {
        pills[i].classList.add('is-active');
        break;
      }
    }
  }
})();

(function () {
  var KEY = 'plp-compare';
  var MAX = 4;
  var FIELDS = [
    ['Price', 'price'], ['Voltage', 'voltage'], ['Amp hours', 'ah'],
    ['Group size', 'group'], ['Chemistry', 'chemistry'], ['Weight', 'weight'], ['Warranty', 'warranty']
  ];

  var bar = document.getElementById('plp-compare-bar');
  var overlay = document.getElementById('plp-compare-overlay');
  if (!bar || !overlay) return;

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(sel) { sessionStorage.setItem(KEY, JSON.stringify(sel)); }

  function cardData(card) {
    return {
      title: card.getAttribute('data-cmp-title') || '',
      url: card.getAttribute('data-cmp-url') || '',
      image: card.getAttribute('data-cmp-image') || '',
      price: card.getAttribute('data-cmp-price') || '',
      voltage: card.getAttribute('data-cmp-voltage') || '',
      ah: card.getAttribute('data-cmp-ah') || '',
      group: card.getAttribute('data-cmp-group') || '',
      chemistry: card.getAttribute('data-cmp-chemistry') || '',
      weight: card.getAttribute('data-cmp-weight') || '',
      warranty: card.getAttribute('data-cmp-warranty') || ''
    };
  }

  function syncBoxes(sel) {
    document.querySelectorAll('[data-plp-compare]').forEach(function (card) {
      var box = card.querySelector('[data-plp-compare-box]');
      if (box) box.checked = Object.prototype.hasOwnProperty.call(sel, card.getAttribute('data-cmp-handle'));
    });
  }

  function renderBar(sel) {
    var handles = Object.keys(sel);
    bar.hidden = handles.length === 0;
    var items = bar.querySelector('[data-plp-bar-items]');
    items.textContent = '';
    handles.forEach(function (h) {
      var d = sel[h];
      var chip = document.createElement('span');
      chip.className = 'plp-compare-bar__chip';
      if (d.image) {
        var img = document.createElement('img');
        img.src = d.image; img.alt = ''; img.width = 32; img.height = 32;
        chip.appendChild(img);
      }
      var name = document.createElement('span');
      name.textContent = d.title;
      chip.appendChild(name);
      var x = document.createElement('button');
      x.type = 'button'; x.textContent = '×';
      x.setAttribute('aria-label', 'Remove ' + d.title);
      x.setAttribute('data-plp-remove', h);
      chip.appendChild(x);
      items.appendChild(chip);
    });
    bar.querySelector('[data-plp-compare-open]').disabled = handles.length < 2;
  }

  function buildTable(sel) {
    var table = overlay.querySelector('[data-plp-compare-table]');
    table.textContent = '';
    var handles = Object.keys(sel);

    var head = document.createElement('tr');
    head.appendChild(document.createElement('th'));
    handles.forEach(function (h) {
      var d = sel[h];
      var td = document.createElement('td');
      if (d.image) {
        var img = document.createElement('img');
        img.src = d.image; img.alt = ''; img.width = 72; img.height = 72;
        td.appendChild(img);
      }
      var a = document.createElement('a');
      a.href = d.url; a.textContent = d.title;
      td.appendChild(a);
      head.appendChild(td);
    });
    table.appendChild(head);

    FIELDS.forEach(function (f) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.textContent = f[0];
      tr.appendChild(th);
      handles.forEach(function (h) {
        var td = document.createElement('td');
        td.textContent = sel[h][f[1]] || '—';
        tr.appendChild(td);
      });
      table.appendChild(tr);
    });
  }

  var limitTimer = null;
  function flashLimit() {
    var el = bar.querySelector('[data-plp-bar-limit]');
    el.hidden = false;
    clearTimeout(limitTimer);
    limitTimer = setTimeout(function () { el.hidden = true; }, 2500);
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-plp-compare-box]');
    if (!box) return;
    var card = box.closest('[data-plp-compare]');
    if (!card) return;
    var h = card.getAttribute('data-cmp-handle');
    var sel = load();
    if (box.checked) {
      if (Object.keys(sel).length >= MAX) { box.checked = false; flashLimit(); return; }
      sel[h] = cardData(card);
    } else {
      delete sel[h];
    }
    save(sel); renderBar(sel); syncBoxes(sel);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-plp-remove]');
    if (rm) {
      var sel = load();
      delete sel[rm.getAttribute('data-plp-remove')];
      save(sel); renderBar(sel); syncBoxes(sel);
      return;
    }
    if (e.target.closest && e.target.closest('[data-plp-compare-clear]')) {
      save({}); renderBar({}); syncBoxes({});
      return;
    }
    if (e.target.closest && e.target.closest('[data-plp-compare-open]')) {
      var s = load();
      if (Object.keys(s).length >= 2) { buildTable(s); overlay.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target === overlay || (e.target.closest && e.target.closest('[data-plp-compare-close]'))) {
      overlay.hidden = true; document.body.style.overflow = '';
    }
  });

  var initial = load();
  renderBar(initial);
  syncBoxes(initial);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-story"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.plp-story__tabs').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-plp-tab]');
      if (!btn) return;
      var apps = btn.closest('.plp-story__apps');
      apps.querySelectorAll('[data-plp-tab]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      apps.querySelectorAll('.plp-story__panel').forEach(function (p) {
        p.hidden = p.id !== btn.getAttribute('data-plp-tab');
      });
    });
  });
})();

(function () {
  var GRAPHS = [
    { name: 'Garmin GPSMAP 400/500 Series', amps: 1.0 },
    { name: 'Garmin GPSMAP 700 Series', amps: 1.5 },
    { name: 'Garmin GPSMAP 800/1000 Series', amps: 2.5 },
    { name: 'Garmin GPSMAP 7400/7600 Series', amps: 3.5 },
    { name: 'Garmin GPSMAP 8400/8600 Series', amps: 6.0 },
    { name: 'Garmin ECHOMAP CHIRP', amps: 1.5 },
    { name: 'Garmin ECHOMAP Plus / UHD', amps: 2.0 },
    { name: 'Garmin ECHOMAP Ultra', amps: 3.0 },
    { name: 'Garmin STRIKER / Plus / Vivid', amps: 1.0 },
    { name: 'Lowrance HDS Gen1', amps: 1.5 },
    { name: 'Lowrance HDS Gen2 / Gen2 Touch', amps: 1.5 },
    { name: 'Lowrance HDS Gen3', amps: 1.6 },
    { name: 'Lowrance HDS Carbon', amps: 2.0 },
    { name: 'Lowrance HDS LIVE', amps: 2.5 },
    { name: 'Raymarine Axiom XL', amps: 7.0 },
    { name: 'Raymarine Dragonfly', amps: 1.0 }
  ];

  function init() {
    document.querySelectorAll('[data-plp-calc]').forEach(function (calc) {
      calc.querySelectorAll('[data-plp-calc-graph]').forEach(function (sel) {
        var none = document.createElement('option');
        none.value = '0';
        none.textContent = 'None';
        sel.appendChild(none);
        GRAPHS.forEach(function (g) {
          var o = document.createElement('option');
          o.value = g.amps;
          o.textContent = g.name + ' (' + g.amps + 'A)';
          sel.appendChild(o);
        });
      });

      var addBtn = calc.querySelector('[data-plp-calc-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var slot = calc.querySelector('[data-plp-calc-slot][hidden]');
          if (slot) slot.hidden = false;
          if (!calc.querySelector('[data-plp-calc-slot][hidden]')) addBtn.hidden = true;
        });
      }

      var go = calc.querySelector('[data-plp-calc-go]');
      if (!go) return;
      go.addEventListener('click', function () {
        var total = 0;
        calc.querySelectorAll('[data-plp-calc-graph]').forEach(function (s) {
          total += parseFloat(s.value) || 0;
        });
        total = Math.round(total * 10) / 10;
        var hoursEl = calc.querySelector('[data-plp-calc-hours]');
        var hours = parseFloat(hoursEl && hoursEl.value);
        var result = calc.querySelector('[data-plp-calc-result]');
        var math = calc.querySelector('[data-plp-calc-math]');
        var note = calc.querySelector('[data-plp-calc-note]');
        var cards = Array.prototype.slice.call(calc.querySelectorAll('[data-plp-calc-card]'));
        cards.sort(function (a, b) {
          return parseFloat(a.getAttribute('data-capacity')) - parseFloat(b.getAttribute('data-capacity'));
        });

        if (!total || !hours || hours <= 0) {
          cards.forEach(function (c) { c.hidden = true; });
          math.textContent = 'Pick at least one graph and enter your hours, then hit calculate.';
          note.textContent = '';
          result.hidden = false;
          return;
        }

        var required = Math.round(total * hours * 10) / 10;
        var pick = null;
        var parallel = false;
        for (var i = 0; i < cards.length; i++) {
          if (parseFloat(cards[i].getAttribute('data-capacity')) * 0.8 >= required) { pick = cards[i]; break; }
        }
        if (!pick && cards.length) {
          pick = cards[cards.length - 1];
          parallel = true;
        }
        cards.forEach(function (c) {
          c.hidden = c !== pick;
          var qty = c.querySelector('[data-plp-calc-qty]');
          if (qty) qty.hidden = !(c === pick && parallel);
        });
        math.textContent = total + 'A × ' + hours + ' hours = ' + required + 'Ah needed';
        if (pick && parallel) {
          note.textContent = 'That draw is beyond a single battery — run two ' + pick.getAttribute('data-name') + ' in parallel, or call a battery expert to size your setup.';
        } else if (pick) {
          note.textContent = 'The ' + pick.getAttribute('data-name') + ' covers your ' + required + 'Ah with usable capacity to spare.';
        } else {
          note.textContent = '';
        }
        result.hidden = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Arrows scroll one card at a time and hide at either end; swipe and the
  // trackpad work without them (CSS scroll-snap).
  function bind(root) {
    var track = root.querySelector('[data-pg-jmc-track]');
    var prev = root.querySelector('[data-pg-jmc-prev]');
    var next = root.querySelector('[data-pg-jmc-next]');
    if (!track || !prev || !next) return;
    var step = function () {
      var slide = track.querySelector('.pg-jmc__slide');
      return slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
    };
    var sync = function () {
      // A few px of slack: snapping and sub-pixel widths rarely land on exactly 0 or max.
      var max = track.scrollWidth - track.clientWidth - 8;
      prev.hidden = track.scrollLeft <= 8;
      next.hidden = track.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }
  function init() { document.querySelectorAll('[data-pg-jmc]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
